module.exports = __webpack_public_path__ + "img/data-guaranteed.cb37b767.webp";